<template>
  <div class="col side-nav">
    <b-form-select
      v-if="organization.is_canadian"
      v-model="locale"
      size="sm"
      :options="localeOptions"
      :disabled="busy"
      class="w-50 mb-3"
      @change="onLocaleChange"
    ></b-form-select>
    <div
      v-for="(p, index) in filteredPages" :key="p.id"
      v-if="!p.is_terms && (p.id == page.id || p.page_id == null || p.page_id == page.id || page.page_id != null && p.page_id == page.page_id)"
    >
      <h5
        class="page-nav"
      >
        <a
          v-if="!p.page_id"
          :href="!p.external_url ? `${iframeUrlPrefix}${p.uri}` : p.external_url"
          :class="`page-nav-link text-dark ${page.id == p.id ? 'font-weight-bold' : ''}`"
          :target="p.external_url ? '_blank' : false"
        >
          {{ p.name }}
          <sup v-if="p.is_home" class="text-muted" :title="trans('client_portal')">
            <small>
              <i class="fa fa-fw fa-home text-muted"></i>
            </small>
          </sup>
          <sup v-if="p.is_my_account" class="text-muted" :title="trans('client_account')">
            <small>
              <i class="fa fa-fw fa-user text-muted"></i>
            </small>
          </sup>
          <sup v-if="p.is_products || p.has_products || p.has_bookings" class="text-muted" :title="trans('online_store')">
            <small>
              <i class="fa fa-fw fa-store-alt text-muted"></i>
            </small>
          </sup>
          <sup v-if="p.is_staff_home" class="text-muted" :title="trans('staff_portal')">
            <small>
              <i class="fa fa-fw fa-chalkboard-teacher text-muted"></i>
            </small>
          </sup>
          <sup v-if="p.passcode_required" class="text-muted">
            <small>
              <i class="fa fa-fw fa-lock-open"></i>
            </small>
          </sup>
          <sup v-if="organization.auth_user && p.permission != 'public'">
            <small :class="`badge badge-${p.permission == 'admin' ? 'danger' : 'secondary'} text-light`">
              {{ trans(p.permission) }}
            </small>
          </sup>
          <sup v-if="!!p.published_to_partner">
            <small class="badge badge-primary">
              {{ trans('sample') }}
            </small>
          </sup>
          <sup v-if="p.locale" v-b-tooltip.hover :title="trans('locale_desc', {lang: trans(p.locale)})">
            <small :class="`badge ${p.translated_page_id ? 'badge-success' : 'badge-secondary'}`">
              {{ p.locale }}
            </small>
          </sup>
        </a>
        <small v-if="p.page_id" class="ml-3 page-nav-link">
          <a
            :href="!p.external_url ? `${iframeUrlPrefix}${p.uri}` : p.external_url"
            :class="`text-dark ${page.id == p.id ? 'font-weight-bold' : ''}`"
          >
            {{ p.name }}
            <sup v-if="p.is_products || p.has_products || p.has_bookings" class="text-muted" :title="trans('online_store')">
              <small>
                <i class="fa fa-fw fa-store-alt text-muted"></i>
              </small>
            </sup>
            <sup v-if="p.passcode_required" class="text-muted">
              <small>
                <i class="fa fa-fw fa-lock-open"></i>
              </small>
            </sup>
            <sup v-if="organization.auth_user && p.permission != 'public'">
              <small :class="`badge badge-${p.permission == 'admin' ? 'danger' : 'secondary'} text-light`">
                {{ trans(p.permission) }}
              </small>
            </sup>
            <sup v-if="p.locale" v-b-tooltip.hover :title="trans('locale_desc', {lang: trans(p.locale)})">
              <small :class="`badge ${p.translated_page_id ? 'badge-success' : 'badge-secondary'}`">
                {{ p.locale }}
              </small>
            </sup>
          </a>
        </small>
        <b-dropdown
          :id="`page-menu-${p.id}`"
          variant="outline-primary"
          toggle-class="edit px-1 py-0"
          size="sm"
          no-caret
        >
          <template #button-content>
            <small><i class="fa fa-fw fa-ellipsis-v"></i></small>
          </template>
          <b-dropdown-item @click="onClickModify(p)">
            <i class="fa fa-fw fa-edit"></i>
            {{ trans('edit') }}
          </b-dropdown-item>
          <b-dropdown-item v-if="(!p.is_built_in || p.is_home) && !p.has_bookings" @click="onClickDuplicate(p)">
            <i class="fa fa-fw fa-copy"></i>
            {{ trans('duplicate') }}
          </b-dropdown-item>
          <b-dropdown-item v-if="!p.is_built_in" @click="onClickDelete(index, p)">
            <span class="text-danger">
              <i class="fa fa-fw fa-trash"></i>
              {{ trans('remove') }}
            </span>
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item :href="`/organization/${organization.id}/page/${p.id}/qr_code`" target="_blank">
            <i class="fa fa-fw fa-qrcode"></i>
            {{ trans('print_qr_code') }}
          </b-dropdown-item>
          <b-dropdown-item @click="onClickIframe(p)">
            <i class="fa fa-fw fa-code"></i>
            {{ trans('embed_on_your_website') }}
          </b-dropdown-item>
          <b-dropdown-item @click="onClickSetAsHome(p)" v-if="!p.external_url && !p.is_home">
            <i class="fa fa-fw fa-home"></i>
            {{ trans('set_as_home_page') }}
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-header>
            {{ trans('add') }}
          </b-dropdown-header>
          <b-dropdown-item @click="onClickAddBefore(index)">
            <i class="fa fa-fw fa-plus"></i>
            {{ trans('before') }}
          </b-dropdown-item>
          <b-dropdown-item @click="onClickAddAfter(index)">
            <i class="fa fa-fw fa-plus"></i>
            {{ trans('after') }}
          </b-dropdown-item>
          <b-dropdown-item v-if="!p.page_id" @click="onClickAddChild(p)">
            <i class="fa fa-fw fa-plus"></i>
            {{ trans('child_page') }}
          </b-dropdown-item>
        </b-dropdown>
      </h5>
      <nav v-if="!!page && p.id == page.id && page.has_bookings && !!packageCategories" v-for="cat in packageCategories" :key="'cat_'+cat.id" class="nav flex-column ml-3">
        <a :href="`${iframeUrlPrefix}/org/${organization.id}/packages/${cat.id}`" :class="`nav-link nav-package ${cat.visible ? 'text-dark' : 'text-danger'} ${!!packageCategory && packageCategory.id == cat.id ? 'active' : ''}`">
          {{ cat.name }}
        </a>
        <nav v-if="!!packageCategory && packageCategory.id == cat.id || !!package && package.package_category_id == pak.package_category_id" v-for="pak in cat.packages" :key="'pak_'+pak.id" class="nav flex-column ml-4">
          <a :href="`${iframeUrlPrefix}/org/${organization.id}/package/${pak.id}`" :class="`nav-link nav-package ${pak.visible ? 'text-dark' : 'text-danger'} ${!!package && package.id == pak.id ? 'active' : ''}`">
            {{ pak.name }}
          </a>
        </nav>
      </nav>
    </div>
    <b-row class="p-2">
      <b-col class="col-auto">
        <b-button variant="outline-primary" size="sm" class="edit px-2" @click="onClickAppend">
          <i class="fa fa-fw fa-plus"></i>
          <span class="d-none d-md-inline">{{ trans('page') }}</span>
        </b-button>
      </b-col>
      <b-col class="discrete text-right">
        <b-button variant="outline-primary" size="sm" class="px-2" v-b-modal.page-reorder-modal :title="trans('reorder')" v-b-tooltip.hover>
          <i class="fa fa-fw fa-bars"></i>
        </b-button>
        <b-button variant="outline-danger" size="sm" class="px-2 ml-2" @click="onClickDesignMode" :title="trans('design_mode')" v-b-tooltip.hover>
          <i class="fa fa-fw fa-times"></i>
        </b-button>
      </b-col>
    </b-row>
    <page-modal
      :organization="organization"
      :clientTabs="clientTabs"
      :page="edit_page"
      :after="after"
      :nested="nested"
      :is-staff="page.is_staff"
      :pages="pages"
      @saved="onSaved"
      @hidden="onHidePageModal"
    ></page-modal>
    <duplicate-page-modal
      :organization="organization"
      :page="duplicate_page"
      :is-staff="page.is_staff"
    ></duplicate-page-modal>
    <page-reorder-modal
      :organization="organization"
      :is-staff="page.is_staff"
      :locale="locale"
      @saved="pages = $event"
    ></page-reorder-modal>
    <page-iframe-embed-modal
      :organization="organization"
      :page="edit_page"
    ></page-iframe-embed-modal>
  </div>
</template>

<script>
  import PageModal from './PageModal'
  import PageReorderModal from './PageReorderModal'
  import DuplicatePageModal from './DuplicatePageModal'
  import PageIframeEmbedModal from './PageIframeEmbedModal'

  export default {
    props: {
      organization: Object,
      initialPages: Array, // list of all pages to render
      clientTabs: Array, // list of all client tabs
      page: Object, // active page
      packageCategories: Array, // set if page is bookings
      packageCategory: Object, // set if active
      package: Object, // set if active
    },
    components: {
      PageModal,
      PageReorderModal,
      DuplicatePageModal,
      PageIframeEmbedModal,
    },
    data() {

      let locale = null

      if (localStorage && localStorage.getItem(`locale_${this.organization.id}`)) {
        locale = localStorage.getItem(`locale_${this.organization.id}`)
      }

      return {
        trans: trans,
        iframeUrlPrefix: _.iframeUrlPrefix,
        pages: _.cloneDeep(this.initialPages),
        edit_page: null,
        duplicate_page: null,
        nested: false,
        after: null,
        localeOptions: [
          {text: trans('all_languages'), value: null},
          {text: trans('french'), value: 'fr'},
          {text: trans('english'), value: 'en'},
        ],
        locale: locale,
        busy: false,
      }
    },
    computed: {
      filteredPages() {
        return _.filter(this.pages, p => {
          if (!this.locale || this.locale == 'null' || !this.organization.is_canadian) return true
          return p.locale == this.locale || (this.locale == this.organization.locale && p.locale == null)
        })
      },
      hasLocale() {
        return _.filter(this.pages, p => p.locale != null).length > 0
      }
    },
    methods: {
      onClickSetAsHome(page) {
        this.busy = true
        let url = `/organization/${this.organization.id}/page/${page.id}/set_as_home`
            axios.post(url)
            .then(response => {
             window.location.reload()
            })
            .catch(error => {
              this.busy = false
              this.error = _.errorFromAjax(error)
              _.toastError(this, this.error)
            })
      },
      onClickAppend() {
        this.edit_page = null
        this.after = _.reduce(this.pages, (last_id, page) => {
          if (page.page_id == null) last_id = page.id
          return last_id
        }, null)
        this.$bvModal.show('page-modal')
      },
      onHidePageModal() {
        this.edit_page = null
        this.duplicate_page = null
        this.after = null
        this.nested = false
      },
      onClickModify(page) {
        this.edit_page = page
        this.$bvModal.show('page-modal')
      },
      onClickDuplicate(page) {
        this.duplicate_page = page
        this.$bvModal.show('duplicate-page-modal')
      },
      onClickDelete(index, page) {
        if (_.filter(this.pages, {page_id: page.id}).length > 0) {
          this.$bvModal.msgBoxOk(trans('cannot_delete_page_with_child_pages'))
          return
        }
        this.$bvModal.msgBoxConfirm(trans('remove_page_confirm'), {
          title: trans('remove'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: trans('remove'),
          cancelTitle: trans('cancel'),
        })
        .then(value => {
          if (value) {
            this.busy = true
            this.error = null
            let url = `/organization/${this.organization.id}/page/${page.id}`
            axios.delete(url)
            .then(response => {
              if (this.page.id == page.id)
                window.location = `/org/${this.organization.id}${page.is_staff ? '/staff' : ''}`
              else
                this.pages.splice(index, 1)
            })
            .catch(error => {
              this.busy = false
              this.error = _.errorFromAjax(error)
              _.toastError(this, this.error)
            })
          }
        })
      },
      onClickAddBefore(index) {
        this.edit_page = null
        this.nested = false
        this.after = this.filteredPages[index-1]
        this.after = this.after ? this.after.id : null
        this.$bvModal.show('page-modal')
      },
      onClickAddAfter(index) {
        this.edit_page = null
        this.nested = false
        this.after = this.filteredPages[index]
        this.after = this.after ? this.after.id : null
        this.$bvModal.show('page-modal')
      },
      onClickAddChild(page) {
        this.edit_page = null
        this.nested = true
        this.after = page
        this.after = this.after ? this.after.id : null
        this.$bvModal.show('page-modal')
      },
      onSaved(page) {
        let index = _.findIndex(this.pages, {id: page.id})
        if (index >= 0)
          this.pages.splice(index, 1, page)
        else
          window.location = _.iframeUrlPrefix + page.uri
      },
      onClickDesignMode() {
        this.busy = true
        this.error = null
        const url = `/org/${this.organization.id}/design_mode`
        axios.post(url, {
          is_editing_microsite: !this.organization.is_editing_microsite
        })
        .then(response => {
          window.location.reload()
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          _.toastError(this, this.error)
        })
      },
      onClickIframe(page) {
        this.edit_page = page
        this.$bvModal.show('page-iframe-embed-modal')
      },
      onLocaleChange(locale) {
        if (localStorage) {
          localStorage.setItem(`locale_${this.organization.id}`, locale)
        }
      }
    },
    mounted() {
      window.sideNavPages = this
    },
  }
</script>
